/*
  Cards de prova social — os pontinhos do carrossel mobile.

  A rolagem em si é toda nativa (scroll-snap): arraste, toque e trackpad saem
  de graça e funcionam mesmo se este arquivo não carregar. O JS aqui só faz
  duas coisas: acender o pontinho certo e levar ao card quando alguém clica
  num deles.

  No desktop a lista vira grade e deixa de rolar; o componente detecta isso
  pelo scrollWidth e simplesmente não faz nada. Não há autoplay — a referência
  também não tem, e depoimento que troca sozinho tira a leitura de quem está
  no meio de uma frase.

  Ser custom element é o que faz isso sobreviver ao editor de temas: quando a
  seção é re-renderizada, o connectedCallback roda de novo sozinho.
*/
if (!customElements.get('social-proof-cards')) {
  customElements.define(
    'social-proof-cards',
    class SocialProofCards extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-spc-track]');
        this.dots = Array.from(this.querySelectorAll('[data-spc-dot]'));
        if (!this.track || !this.dots.length) return;

        this.slides = Array.from(this.track.querySelectorAll('[data-spc-slide]'));
        this.index = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });

        this.dots.forEach((dot) => {
          dot.addEventListener('click', () => this.goTo(Number(dot.dataset.index)));
        });

        // A largura do card vem do layout, então mudar de grade para carrossel
        // (ou a fonte chegar tarde) invalida qualquer medida guardada. Por isso
        // nada é guardado: tudo é lido do rect na hora.
        this.onResize = () => this.sync();
        window.addEventListener('resize', this.onResize);

        this.sync();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        clearTimeout(this.settleTimer);
      }

      /* Na grade do desktop não há transbordo — aí o componente se cala. */
      get scrollable() {
        return this.track.scrollWidth > this.track.clientWidth + 1;
      }

      goTo(index) {
        if (!this.scrollable) return;
        const slide = this.slides[index];
        if (!slide) return;

        // O índice é atualizado na hora, não quando a rolagem assentar: o
        // evento scroll pode ser adiado ou agrupado pelo navegador, e aí o
        // pontinho ficaria parado enquanto o card já mudou.
        this.index = index;
        this.syncDots();

        const delta = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({
          left: this.track.scrollLeft + delta,
          behavior: this.motion.matches ? 'auto' : 'smooth',
        });
      }

      onScroll() {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.sync(), 120);
      }

      /* Card ativo = aquele cuja borda esquerda está mais perto da borda
         esquerda da trilha, que é o mesmo critério do scroll-snap-align. */
      sync() {
        if (!this.scrollable) return;
        const left = this.track.getBoundingClientRect().left;
        let best = 0;
        let bestDistance = Infinity;

        this.slides.forEach((slide, i) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - left);
          if (distance < bestDistance) {
            bestDistance = distance;
            best = i;
          }
        });

        this.index = best;
        this.syncDots();
      }

      syncDots() {
        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    }
  );
}
